import { RecurringTaskView } from '../../../services/RecurringTaskService/types';

// The date TextFields use type="date", which only renders YYYY-MM-DD values.
const toDateInputValue = (value?: string): string | undefined => value?.split('T')[0];

/** Normalizes API date strings (full ISO datetime) to YYYY-MM-DD so the edit form's date inputs populate. */
export const normalizeRecurringTaskDates = (task: RecurringTaskView): RecurringTaskView => ({
  ...task,
  startDate: toDateInputValue(task.startDate) ?? task.startDate,
  endDate: toDateInputValue(task.endDate),
});

/** Creates a blank RecurringTaskView with sensible defaults for the create form. */
export const createDefaultRecurringTask = (): RecurringTaskView => ({
  id: '',
  templateTitle: '',
  priority: 'MED',
  category: '',
  defaultAssignee: '',
  defaultAssigneeName: '',
  defaultTeam: '',
  startDate: new Date().toISOString().split('T')[0],
  isActive: true,
  createdBy: '',
  createdDate: new Date().toISOString(),
  generatedTicketCount: 0,
  canGenerate: false,
  schedule: {
    type: 'DAILY',
    interval: 1,
    weekDays: [],
  },
  generatedTicketIds: [],
});
